import { useTheme } from '@components/theme';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import classNames from 'classnames';
import React from 'react';
import { MERCH_GROUP_URL_PREFIX } from '@components/shared/shop/model/MerchGroup';
import { MERCH_GROUP_CATEGORY_URL_PREFIX } from '@components/shared/shop/model/MerchGroupCategory';
import { IShopNavigationMenuItem } from '../../model';
import styles from './CategoryList.module.scss';

interface ICategoryListProps{
  menuItem: IShopNavigationMenuItem;
  canonicalParentSlug: string;
}

const CategoryList = ({
  menuItem,
}: ICategoryListProps) => {
  const theme = useTheme();

  if (!menuItem) {
    return null;
  }

  return (
    <div className={styles.CategoryList}>
      <a
        className={classNames(
          theme.styles.Title3,
          styles.Title,
        )}
        href={`${MERCH_GROUP_CATEGORY_URL_PREFIX}/${menuItem.slug}`}
        onClick={() => {
          analyticsTrack('shop_nav_item_clicked', {
            title: `Shop Navigation Menu`,
            menuItem,
          });
        }}
      >
        {menuItem.title}
      </a>
      <ul className={styles.List}>
        {menuItem.children.map((item) => (
          <li key={item.id}>
            <a
              href={`${MERCH_GROUP_URL_PREFIX}/${item.slug}`}
              onClick={() => {
                analyticsTrack('shop_nav_item_clicked', {
                  title: `Shop Navigation Menu`,
                  item,
                });
              }}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryList;
